import { GraphQLClient } from 'graphql-request';

const graphQLClient = new GraphQLClient('/api/hank/v1/graphql', {
  credentials: 'include',
  errorPolicy: 'all'
});

const getHeaders = (extraHeaders?: Record<string, string>) => {
  return {
    'Accept': 'application/json',
    'x-http-caller-id': process.env.npm_package_name,
    'x-http-caller-version': process.env.npm_package_version,
    'x-data-origin': 'dfp',
    'x-data-legitimacy': 'LEGITIMATE',
    ...extraHeaders
  };
};

export const hankFetcher = <T>({ query, variables, extraHeaders }: {
  query: string;
  variables?: { [x: string]: unknown };
  extraHeaders?: Record<string, string>;
}) =>
    graphQLClient.rawRequest<T>(query, variables, getHeaders(extraHeaders));
